/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Point
 * 2 = LineString
 * 3 = Polygon
 * 4 = MultiPoint
 * 5 = MultiLineString
 * 6 = MultiPolygon
 * 7 = GeometryCollection
 * 8 = CircularString
 * 9 = CompoundCurve
 * 10 = CurvePolygon
 * 11 = MultiCurve
 * 12 = MultiSurface
 * 13 = Curve
 * 14 = Surface
 * 15 = PolyhedralSurface
 * 16 = TIN
 */
export enum OgcGeometryType {
  Point = 1,
  LineString = 2,
  Polygon = 3,
  MultiPoint = 4,
  MultiLineString = 5,
  MultiPolygon = 6,
  GeometryCollection = 7,
  CircularString = 8,
  CompoundCurve = 9,
  CurvePolygon = 10,
  MultiCurve = 11,
  MultiSurface = 12,
  Curve = 13,
  Surface = 14,
  PolyhedralSurface = 15,
  TIN = 16
}
